import { Datagrid, TextField } from 'react-admin'

import CTList from '../List'
import { ContentRefField, SFMSSearchFilter } from './common'

export const SFMSWaitingTenderDecisionList = (props: any) => {
  return (
    <CTList
      bulkActionButtons={false}
      filters={<SFMSSearchFilter />}
      title="Shipper Loads - Waiting Tender Decision"
      {...props}
    >
      <Datagrid optimized>
        <ContentRefField source="id" label="Content" record={props.record} />
        <TextField source="duration" label="Received" />
        <TextField source="origin_location" label="Origin" />
        <TextField source="dest_location" label="Destination" />
        <TextField source="source" label="Shipper Name" />
      </Datagrid>
    </CTList>
  )
}
